export const pascalCaseToKebabCase = (string: string): string => {
  return string
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();
};
